export class Label {
  constructor(public name: string, public value: string) {}
}

export class Consent {
  constructor(public code: string, public channel: string) {}
}

export class ConsentWithLabel {
  constructor(public consent: Consent, public label: Label) {}
}

export class ConsentsOption {
  constructor(public id: string, public channel: string, public checkboxLabel: string) {}
}

export class Preferences {
  constructor(public id: string, public value: boolean) {}
}

export class PreferencesOption {
  constructor(public id: string, public label: string, public value: boolean) {}
}
